export default [
    {
        "value": "Brasileira",
        "text": "Brasileira"
    },
    {
        "value": "Estrangeira",
        "text": "Estrangeira"
    }
]